var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { identity } from 'lodash';
var default_1 = /** @class */ (function () {
    function default_1(acceptableId, pip, jwt) {
        this.acceptableId = acceptableId;
        this.pip = pip;
        this.jwt = jwt;
    }
    default_1.prototype.acceptable = function (languages) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!this._acceptable) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.pip.getAcceptable(this.acceptableId, this.jwt, languages)];
                    case 1:
                        _a._acceptable = _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/, this._acceptable];
                }
            });
        });
    };
    default_1.prototype.isAccepted = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var acceptable;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.acceptable()];
                    case 1:
                        acceptable = _b.sent();
                        return [2 /*return*/, acceptable.latest_version.number === ((_a = acceptable.latest_acceptance) === null || _a === void 0 ? void 0 : _a.version.number)];
                }
            });
        });
    };
    default_1.prototype.accept = function () {
        return __awaiter(this, void 0, void 0, function () {
            var acceptable;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.acceptable()];
                    case 1:
                        acceptable = _a.sent();
                        return [4 /*yield*/, this.pip.sendAcceptance(acceptable, this.jwt)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return default_1;
}());
export default default_1;
var PIPAdminAcceptable = /** @class */ (function () {
    function PIPAdminAcceptable(acceptableId, pip) {
        this.acceptableId = acceptableId;
        this.pip = pip;
    }
    PIPAdminAcceptable.prototype.acceptableItem = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!this._acceptableItem) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.pip.getAcceptableItem(this.acceptableId)];
                    case 1:
                        _a._acceptableItem = _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/, this._acceptableItem];
                }
            });
        });
    };
    PIPAdminAcceptable.prototype.acceptable = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!this._acceptableVersion) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.pip.getAcceptable(this.acceptableId, true)];
                    case 1:
                        _a._acceptableVersion = _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/, this._acceptableVersion];
                }
            });
        });
    };
    PIPAdminAcceptable.prototype.isAccepted = function () {
        return __awaiter(this, void 0, void 0, function () {
            var acceptable;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.acceptable()];
                    case 1:
                        acceptable = _a.sent();
                        return [2 /*return*/, this.pip.currentUserHasAccepted(acceptable)];
                }
            });
        });
    };
    PIPAdminAcceptable.prototype.content = function (languages) {
        return __awaiter(this, void 0, void 0, function () {
            var acceptableItem, acceptableVersion, content, matchableLanguages, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.acceptableItem()];
                    case 1:
                        acceptableItem = _a.sent();
                        return [4 /*yield*/, this.acceptable()];
                    case 2:
                        acceptableVersion = _a.sent();
                        content = acceptableVersion.content;
                        console.log('Content', content);
                        matchableLanguages = __spreadArrays(languages, [acceptableItem.default_content_language_code]);
                        console.log('matchableLanguages: ', matchableLanguages);
                        result = matchableLanguages
                            .map(function (lng) { return content.find(function (c) { return c.language_code === lng; }); })
                            .find(identity);
                        if (!result) {
                            throw 'No acceptable matches the languages supplied. Default content is presumably not configured.';
                        }
                        return [2 /*return*/, result];
                }
            });
        });
    };
    PIPAdminAcceptable.prototype.accept = function (content) {
        return __awaiter(this, void 0, void 0, function () {
            var acceptable;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.acceptable()];
                    case 1:
                        acceptable = _a.sent();
                        return [4 /*yield*/, this.pip.sendAcceptance(acceptable, content)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return PIPAdminAcceptable;
}());
export { PIPAdminAcceptable };
//# sourceMappingURL=acceptable.js.map